// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {
  FlatList,
  ActivityIndicator,
  RefreshControl,
  View,
  StyleSheet,
} from 'react-native';
import Text from '../../../components/Text';
import {useDispatch, useSelector} from 'react-redux';
import MySearchbar from '../../../components/MySearchbar';
import NavbarWithAction from '../../../components/NavbarWithAction';

import {RootStore} from '../../../redux/store';
import {useNavigation} from '@react-navigation/native';
import Center from '../../../components/Center';
import {colorSwatches, styles as globalStyles} from '../../../styles';
import {Card, Menu} from 'react-native-paper';
import {DeleteStorage, GetStorages, StorageSearch} from '../storagesReducer';
import {useCallback} from 'react';
import {Storage} from '../types';
import {permissionToBool} from '../../../utils';
import IconButton from '../../../components/IconButton';
import Container from '../../../components/Container';
import {showKeyboardAwareAlert} from '../../../utils/keyboard';

const Storages: React.FC = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const {storages, loading} = useSelector((state: RootStore) => state.storages);
  const {unitLinks} = useSelector((state: RootStore) => state.units);
  const currentUnitLink = unitLinks.find(link => link.isDefault === true);
  const [isNavbarShown, setIsNavbarShown] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    dispatch(GetStorages());
  }, []);

  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    dispatch(GetStorages());
    setRefreshing(false);
  }, []);

  const showDeletePrompt = (storageId: string) => {
    showKeyboardAwareAlert(
      '',
      'Do you really want to delete storage ?',
      [
        {
          text: 'NO',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        {
          text: 'YES',
          onPress: () => dispatch(DeleteStorage(storageId)),
        },
      ],
      {
        cancelable: true,
      },
    );
  };

  return (
    <Container>
      {isNavbarShown ? (
        <NavbarWithAction
          navigation={navigation}
          title="Storages"
          hasBackArrow
          showCurrentUnit
          hasAdd={permissionToBool(
            currentUnitLink?.storagePermission?.charAt(3),
          )}
          hasSignOut={false}
          onClickSearch={() => setIsNavbarShown(false)}
          hasSearch={storages?.length > 0}
          onClickAdd={() => navigation.navigate('Add Storage')}
          showUnitPicture={false}
          onClickFilter={() => null}
          hasFilter={false}
          permissionSource="storagePermission"
          fullScreen
        />
      ) : (
        <MySearchbar
          placeholder="Search by bin location"
          value={searchTerm}
          setValue={(val: string) => {
            setSearchTerm(val);
            dispatch(StorageSearch(val));
          }}
          resetSearch={() => {
            setIsNavbarShown(true);
            setSearchTerm('');
            dispatch(StorageSearch(''));
          }}
        />
      )}
      {loading ? (
        <ActivityIndicator
          animating={true}
          color={colorSwatches.primary.color}
          style={styles.activityIndicator}
        />
      ) : (
        <FlatList
          refreshControl={
            <RefreshControl onRefresh={onRefresh} refreshing={refreshing} />
          }
          data={storages}
          style={styles.flatList}
          ListFooterComponent={<View style={styles.footer} />}
          ListEmptyComponent={<Center>No storages found</Center>}
          renderItem={({item}) => (
            <StorageItem
              key={item.id}
              storage={item}
              onSelectDelete={() => {
                showDeletePrompt(item.id);
              }}
              itemClickHandler={() =>
                navigation.navigate('Storage Detail', {storage: item})
              }
              onSelectEdit={() =>
                navigation.navigate('Edit Storage', {storage: item})
              }
              currentUnitLink={currentUnitLink}
            />
          )}
        />
      )}
    </Container>
  );
};

const StorageItem = ({
  storage,
  onSelectEdit,
  onSelectDelete,
  itemClickHandler,
  currentUnitLink,
}: {
  storage: Storage;
  itemClickHandler: () => void;
  onSelectDelete: () => void;
  onSelectEdit: () => void;
  currentUnitLink: UnitLink;
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  return (
    <Card style={styles.card} onPress={() => itemClickHandler()}>
      <View style={styles.cardContent}>
        <View style={styles.cardTextContainer}>
          <View style={styles.cardTextRow}>
            <Text style={styles.storageBinText}>{storage.storageBin}</Text>
          </View>
          <Text>{storage.binLocation}</Text>
          <Text>{storage.monthlyCost?.toString()}</Text>
          <View style={styles.dateContainer}>
            <Text>
              {new Date(storage.dateFrame.startDate).toLocaleDateString()} .{' '}
              {new Date(storage.dateFrame.endDate).toLocaleDateString()}
            </Text>
          </View>
        </View>
        {(permissionToBool(currentUnitLink?.storagePermission?.charAt(1)) ||
          permissionToBool(currentUnitLink?.storagePermission?.charAt(4))) && (
          <View style={styles.menuContainer}>
            <Menu
              visible={menuVisible}
              onDismiss={() => setMenuVisible(false)}
              anchor={
                <IconButton
                  icon="ellipsis-vertical"
                  iconColor={'#718096'}
                  size={24}
                  onPress={() => setMenuVisible(true)}
                />
              }>
              {permissionToBool(
                currentUnitLink?.storagePermission?.charAt(1),
              ) && (
                <Menu.Item
                  onPress={() => {
                    setMenuVisible(false);
                    onSelectEdit();
                  }}
                  title="Edit"
                />
              )}
              {permissionToBool(
                currentUnitLink?.storagePermission?.charAt(4),
              ) && (
                <Menu.Item
                  onPress={() => {
                    setMenuVisible(false);
                    onSelectDelete();
                  }}
                  title="Delete"
                />
              )}
            </Menu>
          </View>
        )}
      </View>
    </Card>
  );
};

const styles = StyleSheet.create({
  activityIndicator: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  flatList: {
    marginVertical: 12,
    marginHorizontal: 8,
    flex: 1,
  },
  footer: {
    height: 32,
  },
  card: {
    borderRadius: 8,
    marginVertical: 8,
  },
  cardContent: {
    flexDirection: 'row',
    padding: 8,
    marginVertical: 4,
    justifyContent: 'space-between',
  },
  cardTextContainer: {
    flex: 1,
    marginLeft: 8,
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  cardTextRow: {
    flexDirection: 'row',
  },
  storageBinText: {
    fontSize: 18,
  },
  dateContainer: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 8,
    justifyContent: 'space-between',
  },
  menuContainer: {
    marginTop: 12,
    marginRight: 16,
  },
});

export default Storages;
